module.exports = __webpack_public_path__ + "static/img/doctorT.507ac29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctorT.png
// module id = E/JZ
// module chunks = 301 302 303 304